/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandshake = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m21.818 4-3.909.994-.545.596-2-.596c-.546-.199-1.091 0-1.364.1l-2.09 1.689-1.183-.497c-.181-.1-.636-.298-1.09-.298H6.454c0-.597-.364-.994-.819-1.094L2.273 4H2.09C1.273 4 1 4.696 1 5.093v8.249c0 .894.545 1.49 1.364 1.49h1.909c.272 0 .454-.1.727-.199l5.364 4.77c.454.398 1 .597 1.545.597.455 0 .91-.1 1.273-.398l3.727-2.285.182-.1c.364-.198.727-.496.818-1.192 0-.298 0-.596-.09-.895l.908-.695c.273.298.637.397 1 .397h1.818c.819 0 1.455-.695 1.455-1.59V5.093C22.91 4.696 22.636 4 21.818 4zM3.636 12.845h-.818V6.186l1.727.497zm8.546 5.068c-.182.1-.455.199-.728 0l-5.727-5.168.546-4.77h3.363s.182 0 .364.1l.09.099L9 9.068a2.742 2.742 0 0 0-.91 1.69c-.09.695.092 1.49.637 2.087.728.795 1.728.994 2.546.497l2.09-1.094 1.728 2.386c.182.298.545.695.727.993zm4.545-4.472-.09-.1-2.183-2.881c-.272-.299-.545-.398-.818-.398-.182 0-.363.1-.545.1l-2.637 1.39c-.181.1-.272.1-.454-.099-.09-.099-.182-.298-.09-.497 0-.099.09-.298.18-.298l4.637-3.677h.182l2.727.795.546 4.77zm4.364-.596h-1.182l-.727-6.162L21 6.186v6.659z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHandshake as Handshake };
